import axios from "./axios";

export const isSessionAuthenticated = async () => {
    const response = await axios.get(process.env.REACT_APP_API_URL + "/auth/refresh");
    return response.status === 200;
}